function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import moment from 'moment';
import pathOr from 'ramda/src/pathOr';
import { fetchCodeTypes, fetchProductRemovalReasons } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
import CustomerLocaleKeys from '../../../../locales/keys';
import { BILLER_RULE_INSTANCE_TYPE, NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../../reducers/selectors/customer.selectors';
import { removeProducts, setRemoveProductExecutionOptions } from '../../../../reducers/actions/customer.products.actions';
import { CurrentProductDetailSelector } from '../../../../reducers/selectors/customer.product.detail.selectors';
import { CandidateBillCyclesSelector } from '../../../../reducers/selectors/customer.billcycle.selectors';
import { GetMaxDateForFutureDatedOrder, IsFutureDatedOrderAllowedInBunt } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { RemoveProductExecutionOptionsSelector } from '../../../../reducers/selectors/customer.products.selectors';
import { retrieveCandidateBillCycles } from '../../../../reducers/actions/customer.billcycle.actions';
import { setReloadSubscriberStateFlag } from '../../../../reducers/actions/customer.actions';
var RemoveProductsController = /*#__PURE__*/function () {
  function RemoveProductsController($ngRedux, uiNotificationService) {
    _classCallCheck(this, RemoveProductsController);
    Object.assign(this, {
      CustomerLocaleKeys: CustomerLocaleKeys,
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      executionOptionsMinDate: moment(new Date()).startOf('day').utc().toISOString(),
      $ngRedux: $ngRedux,
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      onFdoFormValidityChange: this.onFdoFormValidityChange.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(RemoveProductsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          candidateBillCycles: CandidateBillCyclesSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          executionOptions: RemoveProductExecutionOptionsSelector(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfiguration: MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoConfigurationLoaded: MetadataCodeLoadedSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoMaxDate: GetMaxDateForFutureDatedOrder(store),
          isDbss: IsDbss(store),
          oneTimeProductRemovalReason: MetadataOptionsForCodeValuesSelector(CODES.OneTimeProductRemovalReason, store),
          oneTimeProductRemovalReasonLoaded: MetadataCodeLoadedSelector(CODES.OneTimeProductRemovalReason, store),
          orderReason: MetadataOptionsForCodeValuesSelector(CODES.ReasonCodes, store),
          orderReasonLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          productDetails: CurrentProductDetailSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        fetchProductRemovalReasons: fetchProductRemovalReasons,
        removeProducts: removeProducts,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        setReloadSubscriberStateFlag: setReloadSubscriberStateFlag,
        setRemoveProductExecutionOptions: setRemoveProductExecutionOptions
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      var promiseList = [];
      this.isLoadingCodeTypes = true;
      if (!this.state.oneTimeProductRemovalReasonLoaded) {
        promiseList.push(this.actions.fetchProductRemovalReasons());
      }
      if (!this.state.orderReasonLoaded) {
        promiseList.push(this.actions.fetchCodeTypes(CODES.ReasonCodes));
      }
      Promise.all(promiseList).then(function () {
        _this.isLoadingCodeTypes = false;
        _this.removeReasonOptions = _this.isAdHocProduct() ? _this.state.orderReason : _this.state.oneTimeProductRemovalReason;
      });
      if (!this.state.fdoConfigurationLoaded) {
        this.actions.fetchCodeTypes(CODES.FutureDatedOrderConfiguration);
      }
      if (this.state.isDbss) {
        this.actions.retrieveCandidateBillCycles(this.state.currentCustomerId, subscriberOrderTypeEnum.postpaid.value).then(function () {
          _this.setDefaultBillCycle();
        });
      }
      this.confirmationDialogConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.confirmationDialogConfig = api;
        }
      };
      this.model = {
        ItemsToRemove: this.isAdHocProduct() ? this.itemsToRemove.map(function (item) {
          return {
            ProductId: item.Product.Id,
            LockerItemId: item.LockerItemId || item.Id,
            PricingPlanId: item.PricingPlanId || item.PricingPlan.Id,
            IsStandalone: item.Product.Standalone
          };
        }) : this.itemsToRemove.map(function (item) {
          return item.LockerItemId || item.Id;
        }),
        ReasonCode: null,
        SendNotification: true
      };
      this.productToRemoveIsOneTimeBill = this.isProductToRemoveOneTimeBill();
    }
  }, {
    key: "onConfirmationDialogResponse",
    value: function onConfirmationDialogResponse(confirmed) {
      var _this2 = this;
      this.closeConfirmationDialogPopup();
      if (confirmed) {
        return this.actions.removeProducts(this.state.currentCustomerId, this.model, this.isAdHocProduct(), this.state.executionOptions.specifiedDate).then(function () {
          _this2.onSuccess()();
          _this2.uiNotificationService.success(i18n.translate(_this2.CustomerLocaleKeys.REMOVE_PRODUCTS.SUCCESS));
          /*
          * TODO:
          * PD-411357
          * Need to identify when the subscriber has no more products left (Switches to disconnect state) to trigger below action
          */
          _this2.actions.setReloadSubscriberStateFlag(true);
        }).catch(function () {
          _this2.uiNotificationService.error(i18n.translate(_this2.CustomerLocaleKeys.REMOVE_PRODUCTS.ERROR), null, {
            timeout: NOTIFICATION_TIME_LENGTH
          });
        });
      }
    }
  }, {
    key: "isProductToRemoveOneTimeBill",
    value: function isProductToRemoveOneTimeBill() {
      if (pathOr(0, ['length'], this.itemsToRemove) < 1) {
        return false;
      }
      var bris = [];
      this.itemsToRemove.forEach(function (item) {
        var brisItem = pathOr([], ['PricingPlan', 'BillerRuleInstances'], item);
        if (brisItem && !brisItem.length) {
          brisItem = pathOr([], ['PricingPlan', 'BillerRuleInstanceThumbnails'], item);
        }
        bris.push.apply(bris, _toConsumableArray(brisItem));
      });
      return bris.every(function (item) {
        return item.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME;
      });
    }
  }, {
    key: "isAdHocProduct",
    value: function isAdHocProduct() {
      return this.itemsToRemove.every(function (item) {
        return item.Product.ProductClassification === PRODUCT_CLASSIFICATIONS.AD_HOC;
      });
    }
  }, {
    key: "closeConfirmationDialogPopup",
    value: function closeConfirmationDialogPopup() {
      this.handleClose();
      this.confirmationDialogConfig.close();
    }
  }, {
    key: "openConfirmationDialogPopup",
    value: function openConfirmationDialogPopup() {
      this.confirmationDialogConfig.open();
    }
  }, {
    key: "confirmRemoval",
    value: function confirmRemoval() {
      if (this.RemoveProductsForm.$valid) {
        this.hideRemoveProductReasonModal = true;
        this.openConfirmationDialogPopup();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "setDefaultBillCycle",
    value: function setDefaultBillCycle() {
      this.selectedBillCycle = this.state.candidateBillCycles[0];
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(executionOptionsModel) {
      this.actions.setRemoveProductExecutionOptions(executionOptionsModel);
    }
  }, {
    key: "onFdoFormValidityChange",
    value: function onFdoFormValidityChange(message) {
      this.fdoErrorMessageFromComponent = message;
      return message;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./remove.products.popup.html'),
  controller: RemoveProductsController,
  controllerAs: 'RemoveProducts',
  bindings: {
    itemsToRemove: '<',
    onClose: '&',
    onSuccess: '&'
  }
};